import { __assign as b, __spreadArray as x } from "./index.es91.js";
import st from "./index.es92.js";
import Y, { useDebugValue as be, createElement as at, useRef as it, useContext as ct } from "react";
import ut from "./index.es93.js";
import { RULESET as lt } from "./index.es94.js";
import { prefixer as pt, middleware as dt, rulesheet as ht } from "./index.es95.js";
import { stringify as ft, serialize as mt } from "./index.es96.js";
import { compile as yt } from "./index.es97.js";
var T = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", $e = "active", Ve = "data-styled-version", te = "6.1.11", me = `/*!sc*/
`, ye = typeof window < "u" && "HTMLElement" in window, vt = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), Ee = /invalid hook call/i, W = /* @__PURE__ */ new Set(), gt = function(t, e) {
  if (process.env.NODE_ENV !== "production") {
    var n = e ? ' with the id of "'.concat(e, '"') : "", r = "The component ".concat(t).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, o = console.error;
    try {
      var s = !0;
      console.error = function(a) {
        for (var c = [], i = 1; i < arguments.length; i++) c[i - 1] = arguments[i];
        Ee.test(a) ? (s = !1, W.delete(r)) : o.apply(void 0, x([a], c, !1));
      }, it(), s && !W.has(r) && (console.warn(r), W.add(r));
    } catch (a) {
      Ee.test(a.message) && W.delete(r);
    } finally {
      console.error = o;
    }
  }
}, ne = Object.freeze([]), $ = Object.freeze({});
function St(t, e, n) {
  return n === void 0 && (n = $), t.theme !== n.theme && t.theme || e || n.theme;
}
var le = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), wt = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, bt = /(^-|-$)/g;
function Ne(t) {
  return t.replace(wt, "-").replace(bt, "");
}
var Et = /(a)(d)/gi, X = 52, _e = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function pe(t) {
  var e, n = "";
  for (e = Math.abs(t); e > X; e = e / X | 0) n = _e(e % X) + n;
  return (_e(e % X) + n).replace(Et, "$1-$2");
}
var ie, ze = 5381, D = function(t, e) {
  for (var n = e.length; n; ) t = 33 * t ^ e.charCodeAt(--n);
  return t;
}, Be = function(t) {
  return D(ze, t);
};
function Nt(t) {
  return pe(Be(t) >>> 0);
}
function Fe(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function ce(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var Me = typeof Symbol == "function" && Symbol.for, Le = Me ? Symbol.for("react.memo") : 60115, _t = Me ? Symbol.for("react.forward_ref") : 60112, At = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, Pt = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, Ge = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, Ct = ((ie = {})[_t] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, ie[Le] = Ge, ie);
function Ae(t) {
  return ("type" in (e = t) && e.type.$$typeof) === Le ? Ge : "$$typeof" in t ? Ct[t.$$typeof] : At;
  var e;
}
var It = Object.defineProperty, Dt = Object.getOwnPropertyNames, Pe = Object.getOwnPropertySymbols, Rt = Object.getOwnPropertyDescriptor, Ot = Object.getPrototypeOf, Ce = Object.prototype;
function Ye(t, e, n) {
  if (typeof e != "string") {
    if (Ce) {
      var r = Ot(e);
      r && r !== Ce && Ye(t, r, n);
    }
    var o = Dt(e);
    Pe && (o = o.concat(Pe(e)));
    for (var s = Ae(t), a = Ae(e), c = 0; c < o.length; ++c) {
      var i = o[c];
      if (!(i in Pt || n && n[i] || a && i in a || s && i in s)) {
        var u = Rt(e, i);
        try {
          It(t, i, u);
        } catch {
        }
      }
    }
  }
  return t;
}
function V(t) {
  return typeof t == "function";
}
function ve(t) {
  return typeof t == "object" && "styledComponentId" in t;
}
function R(t, e) {
  return t && e ? "".concat(t, " ").concat(e) : t || e || "";
}
function Ie(t, e) {
  if (t.length === 0) return "";
  for (var n = t[0], r = 1; r < t.length; r++) n += t[r];
  return n;
}
function z(t) {
  return t !== null && typeof t == "object" && t.constructor.name === Object.name && !("props" in t && t.$$typeof);
}
function de(t, e, n) {
  if (n === void 0 && (n = !1), !n && !z(t) && !Array.isArray(t)) return e;
  if (Array.isArray(e)) for (var r = 0; r < e.length; r++) t[r] = de(t[r], e[r]);
  else if (z(e)) for (var r in e) t[r] = de(t[r], e[r]);
  return t;
}
function ge(t, e) {
  Object.defineProperty(t, "toString", { value: e });
}
var Tt = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function kt() {
  for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
  for (var n = t[0], r = [], o = 1, s = t.length; o < s; o += 1) r.push(t[o]);
  return r.forEach(function(a) {
    n = n.replace(/%[a-z]/, a);
  }), n;
}
function B(t) {
  for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(e.length > 0 ? " Args: ".concat(e.join(", ")) : "")) : new Error(kt.apply(void 0, x([Tt[t]], e, !1)).trim());
}
var jt = (function() {
  function t(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
  }
  return t.prototype.indexOfGroup = function(e) {
    for (var n = 0, r = 0; r < e; r++) n += this.groupSizes[r];
    return n;
  }, t.prototype.insertRules = function(e, n) {
    if (e >= this.groupSizes.length) {
      for (var r = this.groupSizes, o = r.length, s = o; e >= s; ) if ((s <<= 1) < 0) throw B(16, "".concat(e));
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(r), this.length = s;
      for (var a = o; a < s; a++) this.groupSizes[a] = 0;
    }
    for (var c = this.indexOfGroup(e + 1), i = (a = 0, n.length); a < i; a++) this.tag.insertRule(c, n[a]) && (this.groupSizes[e]++, c++);
  }, t.prototype.clearGroup = function(e) {
    if (e < this.length) {
      var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n;
      this.groupSizes[e] = 0;
      for (var s = r; s < o; s++) this.tag.deleteRule(r);
    }
  }, t.prototype.getGroup = function(e) {
    var n = "";
    if (e >= this.length || this.groupSizes[e] === 0) return n;
    for (var r = this.groupSizes[e], o = this.indexOfGroup(e), s = o + r, a = o; a < s; a++) n += "".concat(this.tag.getRule(a)).concat(me);
    return n;
  }, t;
})(), xt = 1 << 30, K = /* @__PURE__ */ new Map(), ee = /* @__PURE__ */ new Map(), Q = 1, Z = function(t) {
  if (K.has(t)) return K.get(t);
  for (; ee.has(Q); ) Q++;
  var e = Q++;
  if (process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > xt)) throw B(16, "".concat(e));
  return K.set(t, e), ee.set(e, t), e;
}, $t = function(t, e) {
  Q = e + 1, K.set(t, e), ee.set(e, t);
}, Vt = "style[".concat(T, "][").concat(Ve, '="').concat(te, '"]'), zt = new RegExp("^".concat(T, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Bt = function(t, e, n) {
  for (var r, o = n.split(","), s = 0, a = o.length; s < a; s++) (r = o[s]) && t.registerName(e, r);
}, Ft = function(t, e) {
  for (var n, r = ((n = e.textContent) !== null && n !== void 0 ? n : "").split(me), o = [], s = 0, a = r.length; s < a; s++) {
    var c = r[s].trim();
    if (c) {
      var i = c.match(zt);
      if (i) {
        var u = 0 | parseInt(i[1], 10), h = i[2];
        u !== 0 && ($t(h, u), Bt(t, h, i[3]), t.getTag().insertRules(u, o)), o.length = 0;
      } else o.push(c);
    }
  }
};
function Mt() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var He = function(t) {
  var e = document.head, n = t || e, r = document.createElement("style"), o = (function(c) {
    var i = Array.from(c.querySelectorAll("style[".concat(T, "]")));
    return i[i.length - 1];
  })(n), s = o !== void 0 ? o.nextSibling : null;
  r.setAttribute(T, $e), r.setAttribute(Ve, te);
  var a = Mt();
  return a && r.setAttribute("nonce", a), n.insertBefore(r, s), r;
}, Lt = (function() {
  function t(e) {
    this.element = He(e), this.element.appendChild(document.createTextNode("")), this.sheet = (function(n) {
      if (n.sheet) return n.sheet;
      for (var r = document.styleSheets, o = 0, s = r.length; o < s; o++) {
        var a = r[o];
        if (a.ownerNode === n) return a;
      }
      throw B(17);
    })(this.element), this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    try {
      return this.sheet.insertRule(n, e), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.prototype.deleteRule = function(e) {
    this.sheet.deleteRule(e), this.length--;
  }, t.prototype.getRule = function(e) {
    var n = this.sheet.cssRules[e];
    return n && n.cssText ? n.cssText : "";
  }, t;
})(), Gt = (function() {
  function t(e) {
    this.element = He(e), this.nodes = this.element.childNodes, this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    if (e <= this.length && e >= 0) {
      var r = document.createTextNode(n);
      return this.element.insertBefore(r, this.nodes[e] || null), this.length++, !0;
    }
    return !1;
  }, t.prototype.deleteRule = function(e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }, t;
})(), Yt = (function() {
  function t(e) {
    this.rules = [], this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    return e <= this.length && (this.rules.splice(e, 0, n), this.length++, !0);
  }, t.prototype.deleteRule = function(e) {
    this.rules.splice(e, 1), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.rules[e] : "";
  }, t;
})(), De = ye, Ht = { isServer: !ye, useCSSOMInjection: !vt }, qe = (function() {
  function t(e, n, r) {
    e === void 0 && (e = $), n === void 0 && (n = {});
    var o = this;
    this.options = b(b({}, Ht), e), this.gs = n, this.names = new Map(r), this.server = !!e.isServer, !this.server && ye && De && (De = !1, (function(s) {
      for (var a = document.querySelectorAll(Vt), c = 0, i = a.length; c < i; c++) {
        var u = a[c];
        u && u.getAttribute(T) !== $e && (Ft(s, u), u.parentNode && u.parentNode.removeChild(u));
      }
    })(this)), ge(this, function() {
      return (function(s) {
        for (var a = s.getTag(), c = a.length, i = "", u = function(f) {
          var l = (function(E) {
            return ee.get(E);
          })(f);
          if (l === void 0) return "continue";
          var d = s.names.get(l), v = a.getGroup(f);
          if (d === void 0 || v.length === 0) return "continue";
          var _ = "".concat(T, ".g").concat(f, '[id="').concat(l, '"]'), P = "";
          d !== void 0 && d.forEach(function(E) {
            E.length > 0 && (P += "".concat(E, ","));
          }), i += "".concat(v).concat(_, '{content:"').concat(P, '"}').concat(me);
        }, h = 0; h < c; h++) u(h);
        return i;
      })(o);
    });
  }
  return t.registerId = function(e) {
    return Z(e);
  }, t.prototype.reconstructWithOptions = function(e, n) {
    return n === void 0 && (n = !0), new t(b(b({}, this.options), e), this.gs, n && this.names || void 0);
  }, t.prototype.allocateGSInstance = function(e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }, t.prototype.getTag = function() {
    return this.tag || (this.tag = (e = (function(n) {
      var r = n.useCSSOMInjection, o = n.target;
      return n.isServer ? new Yt(o) : r ? new Lt(o) : new Gt(o);
    })(this.options), new jt(e)));
    var e;
  }, t.prototype.hasNameForId = function(e, n) {
    return this.names.has(e) && this.names.get(e).has(n);
  }, t.prototype.registerName = function(e, n) {
    if (Z(e), this.names.has(e)) this.names.get(e).add(n);
    else {
      var r = /* @__PURE__ */ new Set();
      r.add(n), this.names.set(e, r);
    }
  }, t.prototype.insertRules = function(e, n, r) {
    this.registerName(e, n), this.getTag().insertRules(Z(e), r);
  }, t.prototype.clearNames = function(e) {
    this.names.has(e) && this.names.get(e).clear();
  }, t.prototype.clearRules = function(e) {
    this.getTag().clearGroup(Z(e)), this.clearNames(e);
  }, t.prototype.clearTag = function() {
    this.tag = void 0;
  }, t;
})(), qt = /&/g, Ut = /^\s*\/\/.*$/gm;
function Ue(t, e) {
  return t.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(e, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(e, " ")), n.props = n.props.map(function(r) {
      return "".concat(e, " ").concat(r);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = Ue(n.children, e)), n;
  });
}
function Wt(t) {
  var e, n, r, o = $, s = o.options, a = s === void 0 ? $ : s, c = o.plugins, i = c === void 0 ? ne : c, u = function(l, d, v) {
    return v.startsWith(n) && v.endsWith(n) && v.replaceAll(n, "").length > 0 ? ".".concat(e) : l;
  }, h = i.slice();
  h.push(function(l) {
    l.type === lt && l.value.includes("&") && (l.props[0] = l.props[0].replace(qt, n).replace(r, u));
  }), a.prefix && h.push(pt), h.push(ft);
  var f = function(l, d, v, _) {
    d === void 0 && (d = ""), v === void 0 && (v = ""), _ === void 0 && (_ = "&"), e = _, n = d, r = new RegExp("\\".concat(n, "\\b"), "g");
    var P = l.replace(Ut, ""), E = yt(v || d ? "".concat(v, " ").concat(d, " { ").concat(P, " }") : P);
    a.namespace && (E = Ue(E, a.namespace));
    var F = [];
    return mt(E, dt(h.concat(ht(function(m) {
      return F.push(m);
    })))), F;
  };
  return f.hash = i.length ? i.reduce(function(l, d) {
    return d.name || B(15), D(l, d.name);
  }, ze).toString() : "", f;
}
var Xt = new qe(), he = Wt(), We = Y.createContext({ shouldForwardProp: void 0, styleSheet: Xt, stylis: he });
We.Consumer;
Y.createContext(void 0);
function Re() {
  return ct(We);
}
var Oe = (function() {
  function t(e, n) {
    var r = this;
    this.inject = function(o, s) {
      s === void 0 && (s = he);
      var a = r.name + s.hash;
      o.hasNameForId(r.id, a) || o.insertRules(r.id, a, s(r.rules, a, "@keyframes"));
    }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = n, ge(this, function() {
      throw B(12, String(r.name));
    });
  }
  return t.prototype.getName = function(e) {
    return e === void 0 && (e = he), this.name + e.hash;
  }, t;
})(), Zt = function(t) {
  return t >= "A" && t <= "Z";
};
function Te(t) {
  for (var e = "", n = 0; n < t.length; n++) {
    var r = t[n];
    if (n === 1 && r === "-" && t[0] === "-") return t;
    Zt(r) ? e += "-" + r.toLowerCase() : e += r;
  }
  return e.startsWith("ms-") ? "-" + e : e;
}
var Xe = function(t) {
  return t == null || t === !1 || t === "";
}, Ze = function(t) {
  var e, n, r = [];
  for (var o in t) {
    var s = t[o];
    t.hasOwnProperty(o) && !Xe(s) && (Array.isArray(s) && s.isCss || V(s) ? r.push("".concat(Te(o), ":"), s, ";") : z(s) ? r.push.apply(r, x(x(["".concat(o, " {")], Ze(s), !1), ["}"], !1)) : r.push("".concat(Te(o), ": ").concat((e = o, (n = s) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || e in ut || e.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return r;
};
function O(t, e, n, r) {
  if (Xe(t)) return [];
  if (ve(t)) return [".".concat(t.styledComponentId)];
  if (V(t)) {
    if (!V(s = t) || s.prototype && s.prototype.isReactComponent || !e) return [t];
    var o = t(e);
    return process.env.NODE_ENV === "production" || typeof o != "object" || Array.isArray(o) || o instanceof Oe || z(o) || o === null || console.error("".concat(Fe(t), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), O(o, e, n, r);
  }
  var s;
  return t instanceof Oe ? n ? (t.inject(n, r), [t.getName(r)]) : [t] : z(t) ? Ze(t) : Array.isArray(t) ? Array.prototype.concat.apply(ne, t.map(function(a) {
    return O(a, e, n, r);
  })) : [t.toString()];
}
function Jt(t) {
  for (var e = 0; e < t.length; e += 1) {
    var n = t[e];
    if (V(n) && !ve(n)) return !1;
  }
  return !0;
}
var Kt = Be(te), Qt = (function() {
  function t(e, n, r) {
    this.rules = e, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && Jt(e), this.componentId = n, this.baseHash = D(Kt, n), this.baseStyle = r, qe.registerId(n);
  }
  return t.prototype.generateAndInjectStyles = function(e, n, r) {
    var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, n, r) : "";
    if (this.isStatic && !r.hash) if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId)) o = R(o, this.staticRulesId);
    else {
      var s = Ie(O(this.rules, e, n, r)), a = pe(D(this.baseHash, s) >>> 0);
      if (!n.hasNameForId(this.componentId, a)) {
        var c = r(s, ".".concat(a), void 0, this.componentId);
        n.insertRules(this.componentId, a, c);
      }
      o = R(o, a), this.staticRulesId = a;
    }
    else {
      for (var i = D(this.baseHash, r.hash), u = "", h = 0; h < this.rules.length; h++) {
        var f = this.rules[h];
        if (typeof f == "string") u += f, process.env.NODE_ENV !== "production" && (i = D(i, f));
        else if (f) {
          var l = Ie(O(f, e, n, r));
          i = D(i, l + h), u += l;
        }
      }
      if (u) {
        var d = pe(i >>> 0);
        n.hasNameForId(this.componentId, d) || n.insertRules(this.componentId, d, r(u, ".".concat(d), void 0, this.componentId)), o = R(o, d);
      }
    }
    return o;
  }, t;
})(), Je = Y.createContext(void 0);
Je.Consumer;
var ue = {}, ke = /* @__PURE__ */ new Set();
function en(t, e, n) {
  var r = ve(t), o = t, s = !ce(t), a = e.attrs, c = a === void 0 ? ne : a, i = e.componentId, u = i === void 0 ? (function(y, g) {
    var p = typeof y != "string" ? "sc" : Ne(y);
    ue[p] = (ue[p] || 0) + 1;
    var S = "".concat(p, "-").concat(Nt(te + p + ue[p]));
    return g ? "".concat(g, "-").concat(S) : S;
  })(e.displayName, e.parentComponentId) : i, h = e.displayName, f = h === void 0 ? (function(y) {
    return ce(y) ? "styled.".concat(y) : "Styled(".concat(Fe(y), ")");
  })(t) : h, l = e.displayName && e.componentId ? "".concat(Ne(e.displayName), "-").concat(e.componentId) : e.componentId || u, d = r && o.attrs ? o.attrs.concat(c).filter(Boolean) : c, v = e.shouldForwardProp;
  if (r && o.shouldForwardProp) {
    var _ = o.shouldForwardProp;
    if (e.shouldForwardProp) {
      var P = e.shouldForwardProp;
      v = function(y, g) {
        return _(y, g) && P(y, g);
      };
    } else v = _;
  }
  var E = new Qt(n, l, r ? o.componentStyle : void 0);
  function F(y, g) {
    return (function(p, S, C) {
      var k = p.attrs, Qe = p.componentStyle, et = p.defaultProps, tt = p.foldedComponentIds, Se = p.styledComponentId, nt = p.target, rt = Y.useContext(Je), ot = Re(), re = p.shouldForwardProp || ot.shouldForwardProp;
      process.env.NODE_ENV !== "production" && be(Se);
      var we = St(S, rt, et) || $, N = (function(H, G, q) {
        for (var j, I = b(b({}, G), { className: void 0, theme: q }), ae = 0; ae < H.length; ae += 1) {
          var U = V(j = H[ae]) ? j(I) : j;
          for (var A in U) I[A] = A === "className" ? R(I[A], U[A]) : A === "style" ? b(b({}, I[A]), U[A]) : U[A];
        }
        return G.className && (I.className = R(I.className, G.className)), I;
      })(k, S, we), M = N.as || nt, L = {};
      for (var w in N) N[w] === void 0 || w[0] === "$" || w === "as" || w === "theme" && N.theme === we || (w === "forwardedAs" ? L.as = N.forwardedAs : re && !re(w, M) || (L[w] = N[w], re || process.env.NODE_ENV !== "development" || st(w) || ke.has(w) || !le.has(M) || (ke.add(w), console.warn('styled-components: it looks like an unknown prop "'.concat(w, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var oe = (function(H, G) {
        var q = Re(), j = H.generateAndInjectStyles(G, q.styleSheet, q.stylis);
        return process.env.NODE_ENV !== "production" && be(j), j;
      })(Qe, N);
      process.env.NODE_ENV !== "production" && p.warnTooManyClasses && p.warnTooManyClasses(oe);
      var se = R(tt, Se);
      return oe && (se += " " + oe), N.className && (se += " " + N.className), L[ce(M) && !le.has(M) ? "class" : "className"] = se, L.ref = C, at(M, L);
    })(m, y, g);
  }
  F.displayName = f;
  var m = Y.forwardRef(F);
  return m.attrs = d, m.componentStyle = E, m.displayName = f, m.shouldForwardProp = v, m.foldedComponentIds = r ? R(o.foldedComponentIds, o.styledComponentId) : "", m.styledComponentId = l, m.target = r ? o.target : t, Object.defineProperty(m, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(y) {
    this._foldedDefaultProps = r ? (function(g) {
      for (var p = [], S = 1; S < arguments.length; S++) p[S - 1] = arguments[S];
      for (var C = 0, k = p; C < k.length; C++) de(g, k[C], !0);
      return g;
    })({}, o.defaultProps, y) : y;
  } }), process.env.NODE_ENV !== "production" && (gt(f, l), m.warnTooManyClasses = /* @__PURE__ */ (function(y, g) {
    var p = {}, S = !1;
    return function(C) {
      if (!S && (p[C] = !0, Object.keys(p).length >= 200)) {
        var k = g ? ' with the id of "'.concat(g, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(y).concat(k, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), S = !0, p = {};
      }
    };
  })(f, l)), ge(m, function() {
    return ".".concat(m.styledComponentId);
  }), s && Ye(m, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), m;
}
function je(t, e) {
  for (var n = [t[0]], r = 0, o = e.length; r < o; r += 1) n.push(e[r], t[r + 1]);
  return n;
}
var xe = function(t) {
  return Object.assign(t, { isCss: !0 });
};
function tn(t) {
  for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  if (V(t) || z(t)) return xe(O(je(ne, x([t], e, !0))));
  var r = t;
  return e.length === 0 && r.length === 1 && typeof r[0] == "string" ? O(r) : xe(O(je(r, e)));
}
function fe(t, e, n) {
  if (n === void 0 && (n = $), !e) throw B(1, e);
  var r = function(o) {
    for (var s = [], a = 1; a < arguments.length; a++) s[a - 1] = arguments[a];
    return t(e, n, tn.apply(void 0, x([o], s, !1)));
  };
  return r.attrs = function(o) {
    return fe(t, e, b(b({}, n), { attrs: Array.prototype.concat(n.attrs, o).filter(Boolean) }));
  }, r.withConfig = function(o) {
    return fe(t, e, b(b({}, n), o));
  }, r;
}
var Ke = function(t) {
  return fe(en, t);
}, nn = Ke;
le.forEach(function(t) {
  nn[t] = Ke(t);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var J = "__sc-".concat(T, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[J] || (window[J] = 0), window[J] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[J] += 1);
export {
  We as StyleSheetContext,
  Je as ThemeContext,
  tn as css,
  nn as default,
  ve as isStyledComponent,
  nn as styled,
  te as version
};
//# sourceMappingURL=index.es59.js.map
